import { render, staticRenderFns } from "./recordInfo.vue?vue&type=template&id=6ec782a9&scoped=true"
import script from "./recordInfo.vue?vue&type=script&lang=js"
export * from "./recordInfo.vue?vue&type=script&lang=js"
import style0 from "./recordInfo.vue?vue&type=style&index=0&id=6ec782a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec782a9",
  null
  
)

export default component.exports